import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Modal, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { postMethod } from "../../requests";
import { BasicContext } from "../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins, faMoneyCheckDollar, faSpinner } from "@fortawesome/free-solid-svg-icons";

const PurchaseDetailsModal = (props) => {
    const { t } = useTranslation();
    const { up, onClose, showPaymentsList } = props;
    const { checkServerData } = useContext(BasicContext);
    const [paymentDetails, setPaymentDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    const getPassesPayments = async () => {
        const res = await postMethod("/get-passes-payments", { upID: up.up_id });
        if (checkServerData(res)) {
            //console.log(res.data.list);
            setPaymentDetails(res.data.list);
        }
        setLoading(false);
    };

    useEffect(() => {
        getPassesPayments();
        //console.log(up);
        // eslint-disable-next-line
    }, []);

    const data = [
        { text: t("passes.passName"), value: up.pass_name },
        { text: t("payments.orderNumber"), value: up.order_number },
        { text: t("passes.basePrice"), value: `${up.up_base_price.toString().replace(".", ",")} ${t("currency")}` },
        {
            text: t("passes.discount"),
            value: up.discount_code_name ? `${up.discount_value ? `${up.discount_value} ${t("currency")}` : `${up.discount_rate} %`} (${up.discount_code_name})` : <i>{t("lack")}</i>,
        },
        { text: t(`passes.${up.discount_code_name ? "finalPrice" : "setPrice"}`), value: `${up.up_price.toString().replace(".", ",")} ${t("currency")}` },
        { text: t("passes.paidPrice"), value: `${up.up_paid.toString().replace(".", ",")} ${t("currency")}` },
        { text: t("payments.purchaseDate"), value: moment(up.up_purchase_date).format("YYYY-MM-DD") },
        { text: t("passes.entrances"), value: `${up.up_entries - up.up_entries_left}/${up.up_entries}` },
        { text: t("payments.declaredPaymentType"), value: up.declared_payment_type_code ? t(`payments.paymentTypes.${up.declared_payment_type_code}`) : <i>{t("nd")}</i> },
    ];

    return (
        <Modal show={true} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t("payments.purchaseDetails")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <Col xs={12} className="border py-3 shadow-sm rounded">
                            {data.map((e, i) => (
                                <p key={i} className="mb-1">
                                    {e.text}: <strong>{e.value}</strong>
                                </p>
                            ))}
                        </Col>
                        {showPaymentsList && (
                            <Fragment>
                                <Col xs={12}>
                                    <p className="h6 mt-4 mb-3">{t("payments.paymentsList")}</p>
                                </Col>
                                {loading ? (
                                    <Col xs={12} className="my-3 text-center">
                                        <p className="h6">
                                            {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                        </p>
                                    </Col>
                                ) : paymentDetails ? (
                                    <Col xs={12}>
                                        {paymentDetails.length === 0 ? (
                                            <p className="fs-6 opacity-75 my-3">{t("payments.noPayments")}.</p>
                                        ) : (
                                            paymentDetails.map((e, i) => (
                                                <Fragment key={i}>
                                                    <Table className="white-table border" size="sm">
                                                        <tbody>
                                                            <tr>
                                                                <td className="border-bottom-0 pb-0">
                                                                    {t("payments.paymentDate")}: {moment(e.payment_date).format("DD.MM.YYYY")}
                                                                </td>
                                                                <td className="border-bottom-0 pb-0 text-end">
                                                                    <FontAwesomeIcon icon={faCoins} className="me-1 me-lg-2" />
                                                                    {e.payment_amount.toFixed(2).toString().replace(".", ",")} {t("currency")}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="border-bottom-0 pb-0">
                                                                    {t("payments.registerDate")}: {moment(e.create_date).format("YYYY-MM-DD HH:mm:ss")}
                                                                </td>
                                                                <td className="border-bottom-0 pb-0 text-end">
                                                                    <FontAwesomeIcon icon={faMoneyCheckDollar} className="me-1 me-lg-2" />
                                                                    {t(`payments.paymentTypes.${e.payment_type_code}`)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={2} className="border-bottom-0 pb-0">
                                                                    {t("payments.registeredBy")}: {e.user_name} {e.user_surname}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={2}>
                                                                    {t("payments.paymentComment")}: {e.payment_comment ? e.payment_comment : <span className="opacity-50">{t("lack")}</span>}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Fragment>
                                            ))
                                        )}
                                    </Col>
                                ) : null}
                            </Fragment>
                        )}
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={onClose}>
                    {t("close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PurchaseDetailsModal;
